import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import { TableCell, TableRow } from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import {
  ListAlt,
  MenuOpen,
} from "@mui/icons-material";
import BasicMenu from "helpers/menu";

const ExpandedRows = (props) => {
  const {  setOpen, setId, setValue0, parent, handleDelete } = props;
  const list = parent?.subMenus ?? [];
  const [openAction, setOpenAction] = React.useState(false);
  const [code, setCode] = React.useState(0);

  return (
    <>
      {list?.map((row, key) => {
        return (
          <>
            <TableRow
              key={row.id}
            >
              <TableCell align="right" component="th" scope="row" colSpan={2}>
                <MenuOpen />
              </TableCell>
              <TableCell>{row.code}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.link}</TableCell>
              <TableCell>{row.icon}</TableCell>
              <TableCell>
                <BasicMenu
                  onDelete={() => handleDelete(row?.id)}
                  onEdit={() => {
                    setOpen(2);
                    setId(row?.id);
                    setValue0("name", row?.name);
                    setValue0("code", row?.code);
                    setValue0("icon", row?.icon);
                    setValue0("link", row?.link);
                    setValue0("parentId", row?.parentId);
                    setValue0("type", row?.type);
                    setValue0("order", row?.order);

                  }}
                  onAdd={() => {
                    setOpen(1);
                    setValue0("parentId", row?.id);
                    setValue0("type", "action");
                  }}
                  addName="Add Actions"
                  onDetails={() => {
                    setCode(row.code);
                    setOpenAction(true);
                  }}
                  detailsName="Actions"
                />
              </TableCell>
            </TableRow>
            {row?.actions?.map((action) => (
              <TableRow
                key={action.code}
                sx={{
                  display:
                    code === row.code && openAction ? "table-row" : "none",
                }}
              >
                <TableCell align="right" component="th" scope="row" colSpan={2}>
                  <ListAlt />
                </TableCell>
                <TableCell>{action.code}</TableCell>
                <TableCell>{action.name}</TableCell>
                <TableCell component="th" scope="row" colSpan={2}>
                  {action.type}
                </TableCell>
                <TableCell >
                  <BasicMenu
                    onDelete={() => handleDelete(action?.id)}
                    onEdit={() => {
                      setOpen(2);
                      setId(action?.id);
                      setValue0("name", action?.name);
                      setValue0("code", action?.code);
                      setValue0("icon", action?.icon);
                      setValue0("link", action?.link);
                      setValue0("parentId", action?.parentId);
                      setValue0("type", action?.type);
                      setValue0("order", action?.order);
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </>
        );
      })}
    </>
  );
};

const MenuPermissions = ({ category, SetSelectedMenu, location, menus,subMenus,actions }) => {

  
  const subMenuCode = "submenu.menu";

  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [type, setType] = React.useState(category);
  const [deleteUrl, setDeleteActionUrl] = React.useState(null);

  const mainMenus = value["type"] === "action" ? subMenus : menus;


  useEffect(() => {
    SetSelectedMenu({
      menu: "seetings",
      title: "System Permissions",
    });
  }, []);

  const handleDelete = (id) => {
    setDeleteOpen(1);
    setDeleteActionUrl(`/api/structure/menu/${id}`);
    setCount((v) => v + 1);
  };

  const columns = [
    {
      name: "code",
      label: "Code",
    },
    {
      name: "name",
      label: "Name",
    },
    {
      name: "link",
      label: "Link",
    },
    {
      name: "icon",
      label: "Icon",
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => {
          const obj = list.find((vx) => vx.id === v);

          return<div className="flex items-center">
            <BasicMenu
              onDelete={() => handleDelete(v)}
              onEdit={() => {
                setOpen(2);
                // const obj = list.find((vx) => vx.id === v);
                setId(v);
                setValue0("name", obj?.name);
                setValue0("code", obj?.code);
                setValue0("icon", obj?.icon);
                setValue0("link", obj?.link);
                setValue0("order", obj?.order);
                setValue0("type", obj?.type);
                setValue0("order", obj?.order);

              }}
              onAdd={obj?.type==="menu"?() => {
                setOpen(1);
                setValue0("parentId", v);
                setValue0("type", "subMenu");
              }:null}
              addName="Add SubMenu"
            />
          </div>
        },
      },
    },
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const onSuccess = () => setCount((v) => v + 1);

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={deleteUrl}
      />

      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={() => {
          window.location.reload();
        }}
        setOpen={setOpen}
        url={
          open === 1
            ? "/api/structure/menu/create"
            : `/api/structure/menu/update/${id}`
        }
        title={open === 1 ? "Create New " : "Edit"}
        fields={[
          {
            name: "code",
            label: "Code",
            value: value["code"] || "",
            required: true,
            col: 12,
            setValue: (val) => setValue0("code", val),
          },
          {
            name: "name",
            label: "Name",
            value: value["name"] || "",
            required: true,
            col: 12,
            setValue: (val) => setValue0("name", val),
          },
          {
            name: "link",
            label: "Link",
            value: value["link"] || "",
            col: 12,
            setValue: (val) => setValue0("link", val),
          },
          {
            name: "icon",
            label: "Icon",
            value: value["icon"] || "",
            col: 12,
            setValue: (val) => setValue0("icon", val),
          },
          {
            name: "order",
            label: "Order",
            value: value["order"] || "1",
            hidden:value["type"]!=="menu",
            col: 12,
            setValue: (val) => setValue0("order", val),
          },
          {
            name: "parentId",
            label: "parent",
            value: value["parentId"],
            col: 12,
            type: "select",
            hidden: value["type"] === "menu",
            values: mainMenus?.map((item) => ({
              value: item.id,
              label: item.name,
            })),
            setValue: (val) => setValue0("parentId", val),
          },
          {
            name: "type",
            label: "type",
            value: value["type"],
            disabled: true,
            col: 12,
            setValue: (val) => setValue0("type", val),
          },
        ]}
      />
      <DatatableComponent
        order={location.state?.order}
        search={false}
        viewColumns={false}
        searchfield={true}
        onAddNew={() => {
          setOpen(1);
          setValue0("type", category==="action"?"action":"menu");
          setValue0("order", 1);
        }}
        // subMenuCode={subMenuCode}
        // checkSubMenuPermission={true}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        elevation={1}
        columns={columns}
        url={`/api/structure/menu/dataTable?type=${type} & parentId=null&count=${count}`}
        title={``}
        expandableRows={type === "menu"}
        renderExpandableRow={(rowData, rowMeta) => {
          let index2 = rowMeta?.dataIndex;
          return (
            <ExpandedRows
              index={index2}
              handleDelete={handleDelete}
              setOpen={setOpen}
              setId={setId}
              setValue0={setValue0}
              parent={list[index2]}
              setType={setType}
              subMenuCode={subMenuCode}
            />
          );
        }}
      />
    </div>
  );
};

export default MenuPermissions;
